export const formatPhone = (str) => {
  if (!str) {
    return '';
  }

  // incorrect format
  if (str[0] !== '+' || str.length !== 12) {
    return str;
  }

  return `${str.slice(0, 2)} ${str.slice(2, 5)} ${str.slice(5, 8)} ${str.slice(
    8,
    10,
  )} ${str.slice(10)}`;
};

export const formatMbToGb = (mb) => {
  if (!mb && mb !== 0) {
    return '';
  }
  let convertedToString = (mb / 1024).toFixed(1).toString().replace('.', ',');
  let splitted = convertedToString.split(',');
  if (splitted[1] === '0') {
    return splitted[0];
  } else {
    return convertedToString;
  }
};

export const formatTime = (time) => {
  if (!time) {
    return '';
  }
  const date = new Date(time);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};

export const formatFieldName = (field) => {
  try {
    return field.split('_').map(capitalize).join(' ');
  } catch (err) {
    return field;
  }
};

export const capitalize = (str) => {
  if (!str) return '';
  if (str.length === 1) return str.toUpperCase();

  return str[0].toUpperCase() + str.slice(1);
};

export const formatPrice = (priceInput) => {

  if (!priceInput){
    return '';
  }

  const price = typeof priceInput === 'string' ? parseFloat(priceInput) : priceInput;

  if (price % 1 === 0) {
    return price.toString();
  } else {

    return price.toFixed(2);
  }
};
